import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { MetricCard } from './metric-card'

const BloqueVolumen = ({ data }) => (
    <Row className='g-2'>
        <Col xs={6} md={4} lg><MetricCard label='Casos activos' value={data?.casosActivos} colorVariant='azul' nota='(estado actual)' /></Col>
        <Col xs={6} md={4} lg><MetricCard label='Ingresados en período' value={data?.casosIngresadosPeriodo} /></Col>
        <Col xs={6} md={4} lg><MetricCard label='Cerrados en período' value={data?.casosCerradosPeriodo} /></Col>
        <Col xs={6} md={6} lg><MetricCard label='Cerrados con recobro' value={data?.casosCerradosConRecobro} colorVariant='verde' /></Col>
        <Col xs={12} md={6} lg><MetricCard label='Cerrados sin recobro' value={data?.casosCerradosSinRecobro} colorVariant='gris' /></Col>
    </Row>
)
export default BloqueVolumen
